module.exports = __webpack_public_path__ + "static/notifications-a4010ec0309fb5e0123758baaef83ded.png";